import {observable, action, computed, createTransformer, reaction, extendObservable} from "mobx";
import TimesheetService from "../../../../services/TimesheetService";
import moment from 'moment';
import { formatarDataISO8601, formatarValorReal } from "../../../../utils/formatar";

export default class TimesheetsStore  {

    @observable listaItens;
    @observable loading;

    constructor() {
        this.loading = false;
        this.listaItens = [];

        this.timesheetService = new TimesheetService();
    }

    setLista(motsList) {
        this.detalhes.mots = motsList;
    }

    filtrar = (filtro) => {
        this.loading = true;

        this.timesheetService.listarTimesheets(filtro).then(response => {
            this.listaItens = response.data;
            this.loading = false;
        }).catch(erro => {
            console.log(erro);
            this.loading = false;
        });
    }
}